import {
  Col,
  Form, Input, Row, Select,
} from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import * as alertsNames from '@pages/Alertas/helpers/defaultAlerts/alertsNames';
import styles from './GeneralAlarma.module.less';

import LayoutStep from '../../components/LayoutStep';
import SpecialCard from '../../components/SpecialCard';

const { Item } = Form;
const { TextArea } = Input;
const { Option } = Select;

function GeneralAlarma(props) {

  const { onNext, businessData, alarm_id } = props;
  const { t } = useTranslation();

  const isEditDefault = useSelector(({ inverters }) => inverters.isEditDefault);

  return (
    <LayoutStep onNext={onNext}>
      <SpecialCard> 

        <Row gutter={[16, 8]}>
          <Col xs={{span: 24, }} sm={{span: 24, }} md={{span: 12, }} lg={{span: 12, }} xl={{span: 12, }}
          >
            <Item
                className={styles.short_input}
                label={t('views.dynamic_alarms_create_edit.labels.name')}
                name="name"
                rules={[
                  {
                    required: true,
                    message: t('views.dynamic_alarms_create_edit.feedbacks.required_input'),
                  },
                  () => ({
                    validator(_, val) {

                      const alertsDefaults = Object.values(alertsNames);
                      if (!isEditDefault && alertsDefaults.includes(val)) {

                        return Promise.reject(
                          t('views.dynamic_alarms_create_edit.feedbacks.reserved_name'),
                        );

                      }
                      return Promise.resolve();

                    },
                  }),
                ]}
              >
                <Input disabled={isEditDefault} />
              </Item>
          </Col>

          <Col xs={{span: 24, }} sm={{span: 24, }} md={{span: 12, }} lg={{span: 12, }} xl={{span: 12, }}>  
            <Item
              className={styles.short_input}
              label={t('forms.users.labels.business_line')}
              name="business_type_id" //business_type
              rules={[
                {
                  required: true,
                  message: t('forms.users.placeholders.business_line'),
                },
              ]}
            >
              <Select 
                disabled={alarm_id}
                style={{ width: '100%' }} 
                placeholder={t('forms.users.placeholders.business_line')} 
                options={businessData}

              /> 
            </Item>  
          </Col> 
        </Row>

        {/* <Item
          className={styles.large_input}
          label={t('views.dynamic_alarms_create_edit.labels.active/deactive')}
          name="is_active"
          valuePropName="checked"
        >
          <Switch
            disabled={isEditDefault}
          />
        </Item> */}
      </SpecialCard>
    </LayoutStep>
  );

}

GeneralAlarma.propTypes = {
  onNext: PropTypes.func.isRequired,
};

export default GeneralAlarma;
